import { Component, OnInit } from '@angular/core';
import { LoginUnawareComponent } from '../login-unaware-component';
import { GraphClientService } from '../services/graph-client-service';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

const SORTGROUP_TOPROW = 'TopRow';
const SORTGROUP_LINKSROW = 'LinksRow';
const SORTGROUP_LEGALROW = 'LegalRow';

/**
 * Configurable footer, pulls its data from a SharePoint Online list. Number of links,
 * their URLs and text can be customized in the list.
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent extends LoginUnawareComponent implements OnInit {
  public footerContent: { topRow: Array<any>, linksRow: Array<any>, legalRow: Array<any> };

  constructor(diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService) {
    super(diagnosticsFactory.create('FooterComponent'));
  }

  ngOnInit() {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
        const dynamicData = data as any;
        const items: any[] = dynamicData.value;

        const accumulatedContent = items.reduce((content: any, item: any, i: number) => {
          const sortGroup = item.fields.SortGroup;
          switch (sortGroup) {
            case SORTGROUP_TOPROW:
              content.topRow.push(item);
              break;
            case SORTGROUP_LINKSROW:
              content.linksRow.push(item);
              break;
            case SORTGROUP_LEGALROW:
              content.legalRow.push(item);
              break;
            default:
              const message = `ERROR: SortGroup value ${sortGroup} is not supported.`;
              this.diagnostics.logError(message);
              throw new Error(message);
          }
          return content;
        }, { topRow: [], linksRow: [], legalRow: [] });

        const sortFunction = (left: any, right: any) => left.fields.SortOrder - right.fields.SortOrder;
        accumulatedContent.topRow.sort(sortFunction);
        accumulatedContent.linksRow.sort(sortFunction);
        accumulatedContent.legalRow.sort(sortFunction);
        this.footerContent = accumulatedContent;
      }, error => {
        this.diagnostics.logError(`ERROR loading data. Details: ${JSON.stringify(error)}`);
      });
  }
}
